export const INITIAL_INVENTORY_REQUEST = "INITIAL_INVENTORY_REQUEST";
export const FINAL_INVENTORY_REQUEST = "FINAL_INVENTORY_REQUEST";
export const FETCH_INVENTORY_SUCCESS = "FETCH_INVENTORY_SUCCESS";
export const UPDATE_INVENTORIES = "UPDATE_INVENTORIES";
export const CHANGE_SELECT_INVENTORIES = "CHANGE_SELECT_INVENTORIES";
export const CHANGE_TAGS_AVAILABLE = "CHANGE_TAGS_AVAILABLE";
